import React from 'react';
import { Home, Sparkles, Gift, ShoppingBag, MessageCircle } from 'lucide-react';

export type BottomNavTab = 'home' | 'services' | 'bundles' | 'cart' | 'chat';

interface MobileAppTabBarProps {
  cartCount: number;
  onSelectHomeTab: () => void;
  onSelectServicesTab: () => void;
  onSelectBundlesTab: () => void;
  onOpenCart: () => void;
  onOpenChat: () => void;
  activeTab: BottomNavTab;
}

export const MobileAppTabBar: React.FC<MobileAppTabBarProps> = ({
  cartCount,
  onSelectHomeTab,
  onSelectBundlesTab,
  onSelectServicesTab,
  onOpenCart,
  onOpenChat,
  activeTab
}) => {
  return (
    <nav className="mobile-app-tabbar" aria-label="Mobile Bottom Navigation">
      {/* Home Tab */}
      <button
        type="button"
        className={`app-tab-btn ${activeTab === 'home' ? 'active' : ''}`}
        onClick={onSelectHomeTab}
        aria-label="Home"
      >
        <div className="tab-icon-wrap">
          <Home size={20} />
        </div>
        <span className="tab-label">Home</span>
      </button>

      {/* Services Tab */}
      <button
        type="button"
        className={`app-tab-btn ${activeTab === 'services' ? 'active' : ''}`}
        onClick={onSelectServicesTab}
        aria-label="Services Menu"
      >
        <div className="tab-icon-wrap">
          <Sparkles size={20} />
        </div>
        <span className="tab-label">Services</span>
      </button>

      {/* Bundles Tab */}
      <button
        type="button"
        className={`app-tab-btn ${activeTab === 'bundles' ? 'active' : ''}`}
        onClick={onSelectBundlesTab}
        aria-label="Value Bundles"
      >
        <div className="tab-icon-wrap">
          <Gift size={20} />
          <span className="tab-bundle-badge">SAVE</span>
        </div>
        <span className="tab-label">Bundles</span>
      </button>

      {/* Cart Tab with Live Counter */}
      <button
        type="button"
        className={`app-tab-btn app-tab-cart ${activeTab === 'cart' ? 'active' : ''} ${cartCount > 0 ? 'has-items' : ''}`}
        onClick={onOpenCart}
        aria-label={`Cart with ${cartCount} items`}
      >
        <div className="tab-icon-wrap">
          <ShoppingBag size={20} />
          {cartCount > 0 && <span className="tab-cart-badge">{cartCount}</span>}
        </div>
        <span className="tab-label">Cart</span>
      </button>

      {/* Chatbot & Help Tab */}
      <button
        type="button"
        className={`app-tab-btn app-tab-chat ${activeTab === 'chat' ? 'active' : ''}`}
        onClick={onOpenChat}
        aria-label="Chat & Quick Booking"
      >
        <div className="tab-icon-wrap">
          <MessageCircle size={20} />
        </div>
        <span className="tab-label">Chat</span>
      </button>
    </nav>
  );
};
